import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  // set up locales, // sk, en, cz
  const locales = ["sk", "cz"];
  const messages = {} as VueI18n.LocaleMessages;
  locales.forEach(locale => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const commonTexts = require(`./assets/texts/${locale}/common.json`);
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const companyTexts = require(`./assets/texts/${locale}/${process.env.VUE_APP_TEXTS_FILE}`);
    messages[locale] = { ...commonTexts, ...companyTexts };
  });
  return messages;
}

const locales = process.env.VUE_APP_LOCALES.split(",");
const locale =
  locales[
    process.env.VUE_APP_LOCALE_HOSTS.split(",").indexOf(window.location.origin)
  ];

const i18n = new VueI18n({
  locale,
  fallbackLocale: locale,
  sync: true,
  messages: loadLocaleMessages(),

  // Key - language to use the rule for, `'sk'`, in this case
  // Value - function to choose right plural form
  pluralizationRules: {
    /**
     * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
     * @param choicesLength {number}
     * @returns a final choice index to select plural word by
     */
    sk: (choice, choicesLength) => {
      if (choice === 0 || choicesLength === 1) {
        return 0;
      } else if (choice === 1) {
        return 1;
      } else if (choice > 1 && choice < 5) {
        return 2;
      } else {
        return 3;
      }
    },
    cz: (choice, choicesLength) => {
      if (choice === 0 || choicesLength === 1) {
        return 0;
      } else if (choice === 1) {
        return 1;
      } else if (choice > 1 && choice < 5) {
        return 2;
      } else {
        return 3;
      }
    }
  }
});

export default i18n;
